<template>
  <div
    class="card card-body border-start border-start-width-2 border-start-primary"
  >
    <div class="row">
      <div class="col-12 col-md-6">
        <p><strong>Identificador: </strong>{{ contract.idContrato }}</p>
      </div>
      <div class="col-12 col-md-6">
        <p><strong>Número do Contrato: </strong>{{ contract.numero }}</p>
      </div>
      <div class="col-12 col-md-6">
        <p><strong>CNPJ: </strong>{{ contract.cnpj }}</p>
      </div>
      <div class="col-12 col-md-6">
        <p><strong>Contratado: </strong>{{ contract.contratado }}</p>
      </div>
      <div class="col-12 col-md-6">
        <p>
          <strong>Data da Assinatura: </strong>
          {{ dateTimeRmToDateBR(contract.dataAssinatura) }}
        </p>
      </div>
      <div class="col-12 col-md-6">
        <p>
          <strong>Data de Término: </strong>
          {{ dateTimeRmToDateBR(contract.dataTermino) }}
          <span v-html="compare2Dates(new Date(), contract.dataTermino)"></span>
        </p>
      </div>
      <div class="col-12 col-md-6">
        <p><strong>Gestor: </strong>{{ contract.gestor }}</p>
      </div>
      <div class="col-12 col-md-6">
        <p><strong>Gestores: </strong>{{ contract.gestores }}</p>
      </div>
      <div class="col-12 col-md-6">
        <p><strong>Condição: </strong>{{ contract.condicao }}</p>
      </div>
      <div class="col-12 col-md-6">
        <p><strong>Fundamento: </strong>{{ contract.fundamento }}</p>
      </div>
      <div class="col-12 col-md-6">
        <p><strong>Situação: </strong>{{ contract.situacao }}</p>
      </div>
      <div class="col-12 col-md-6">
        <p><strong>Requisição: </strong>{{ contract.requisicao }}</p>
      </div>
      <div class="col-12 col-md-6">
        <p>
          <strong>Valor Original: </strong>
          {{ formatToCurrencyBr(contract.valorOriginal) }}
        </p>
      </div>
      <div class="col-12 col-md-6">
        <p>
          <strong>Valor Pago: </strong>
          {{ formatToCurrencyBr(contract.valorPago) }}
        </p>
      </div>
      <div class="col-12 col-md-6">
        <p><strong>Id Fluig: </strong>{{ contract.idFluig }}</p>
      </div>
      <div class="col-12 col-md-6">
        <p>
          <strong>Centro de Custo: </strong>{{ contract.codCentroCusto }}
          {{ contract.nomeCentroCusto }}
        </p>
      </div>
      <div class="col-12">
        <p><strong>Objeto: </strong>{{ contract.objeto }}</p>
      </div>
      <div class="col-12">
        <p class="mb-0"><strong>Histórico: </strong>{{ contract.historico }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { formatToCurrencyBr } from '@/utils/currency'
import { dateTimeRmToDateBR, compare2Dates } from '@/utils/date'

export default {
  name: 'DetailsContract',

  props: {
    contract: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      formatToCurrencyBr,
      dateTimeRmToDateBR,
      compare2Dates,
    }
  },
}
</script>
